
module.exports.numericThresholdValue = 0.001;

module.exports.venueCode = 
{
    webApp: 'WebApp'
}

module.exports.WebPaymentProviders =
{
    stripe: "Stripe",
    stripeOverPhone: "StripeOverPhone"
}

module.exports.dispatchTypes =
{
    dineIn: "DineIn",
    collection: "Collection",
    delivery: "Delivery"
}

module.exports.saleTypes =
{
    sale: "Sale",
    hold: "hold"
}

module.exports.paymentMethods =
{
    cash: "Cash",
    credit: "Credit",
    venuePaid: "VenuePaid"
}

module.exports.applicationMode =
{
    overPhonePayment: "OverPhonePayment",
    webApp: "WebApp"
}

module.exports.holdReasonCode =
{
    staff: "staff",
    paymentByPhone: "paymentByPhone"
}

module.exports.openingHoursType =
{
    allDayOpen: "allDayOpen",
    allDayClose: "allDayClose",
    timeSlot: "timeSlot"
}

module.exports.businessHourOverridesType =
{
    allDay: "allDay",
    timeSlot: "timeSlot"
}
